// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { FC, SVGProps } from 'react';

const SearchIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_210_7518"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_210_7518)">
        <path
          d="M11 18C12.9333 18 14.5833 17.3193 15.95 15.9578C17.3167 14.5963 18 12.9437 18 11C18 9.06667 17.3167 7.41667 15.95 6.05C14.5833 4.68333 12.9333 4 11 4C9.05633 4 7.40375 4.68333 6.04225 6.05C4.68075 7.41667 4 9.06667 4 11C4 12.9437 4.68075 14.5963 6.04225 15.9578C7.40375 17.3193 9.05633 18 11 18ZM11 19.5C9.8205 19.5 8.71542 19.2769 7.68475 18.8307C6.65392 18.3846 5.75517 17.7782 4.9885 17.0115C4.22183 16.2448 3.61542 15.3461 3.16925 14.3152C2.72308 13.2846 2.5 12.1795 2.5 11C2.5 9.83083 2.72308 8.73083 3.16925 7.7C3.61542 6.66917 4.22183 5.76792 4.9885 4.99625C5.75517 4.22442 6.65392 3.61542 7.68475 3.16925C8.71542 2.72308 9.8205 2.5 11 2.5C12.1692 2.5 13.2692 2.72308 14.3 3.16925C15.3308 3.61542 16.2321 4.22442 17.0038 4.99625C17.7756 5.76792 18.3846 6.66917 18.8307 7.7C19.2769 8.73083 19.5 9.83083 19.5 11C19.5 12.041 19.3234 13.0237 18.9703 13.948C18.6169 14.8723 18.1287 15.7102 17.5057 16.4615L21.5 20.4557L20.4403 21.5L16.4462 17.521C15.6949 18.1442 14.8571 18.6298 13.9327 18.9778C13.0084 19.3259 12.0308 19.5 11 19.5Z"
          fill="black"
          fillOpacity="0.25"
        />
      </g>
    </svg>
);

export default SearchIcon;
